export const DELIVERY_EFFICIENCY_MONITOR = {
   DRIVER_EFFICIENCY_DATA_LOAD: "DRIVER_EFFICIENCY_DATA_LOAD",
    DRIVER_EFFICIENCY_DATA_LOAD_SUCCESS: "DRIVER_EFFICIENCY_DATA_LOAD_SUCCESS",
    DRIVER_EFFICIENCY_DATA_LOAD_FAIL: "DRIVER_EFFICIENCY_DATA_LOAD_FAIL",


    DRIVER_EFFICIENCY_USER_TEAM_LOAD: "DRIVER_EFFICIENCY_USER_TEAM_LOAD_LOAD",
    DRIVER_EFFICIENCY_USER_TEAM_LOAD_SUCCESS: "DRIVER_EFFICIENCY_USER_TEAM_LOADSUCCESS",
    DRIVER_EFFICIENCY_USER_TEAM_LOAD_FAIL: "DRIVER_EFFICIENCY_USER_TEAM_LOAD_FAIL",

    DRIVER_EFFICIENCY_DRIVER_DETAIL_LOAD: "DRIVER_EFFICIENCY_DRIVER_DETAIL_LOAD",
    DRIVER_EFFICIENCY_DRIVER_DETAIL_LOAD_SUCCESS: " DRIVER_EFFICIENCY_DRIVER_DETAIL_LOAD_LOADSUCCESS",
    DRIVER_EFFICIENCY_DRIVER_DETAIL_LOAD_FAIL: "DRIVER_EFFICIENCY_DRIVER_DETAIL_LOADFAIL",

    DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD: "DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD",
    DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD_SUCCESS: " DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD_SUCCESS",
    DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD_FAIL: "DRIVER_EFFICIENCY_ALERT_RULE_DETAIL_LOAD_FAIL",

    DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD: "DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD",
    DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD_SUCCESS: " DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD",
    DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD_FAIL: "DRIVER_EFFICIENCY_STATUS_DETAIL_LOAD",

}